<template>
  <div class="acti-edit">
    <div class="position-relative jp-column">
      <el-image :src="mainBg" class="w-100 title-bg"></el-image>
      <h4 v-if="$i18n.locale !== 'en'" class="jp-en-title">Our business</h4>
      <h1 class="jp-title">{{$t('acti.title')}}</h1>
    </div>
    <section>
      <div class="jp-line"></div>
      <div class="jp-column mt-5">
        <!-- <span class="title jp-grey-bg">{{title}}</span> -->
        <span class="title jp-grey-bg">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{title}}</span>
        </span>
        <span class="en-common-title">{{title_en}}</span>
        <div v-if="type === 1">
          <!-- <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
            <el-col :span="10" :xs="24" class="mb-3">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology2" class="image w-100 technology-img">
              </div>
            </el-col>
            <el-col :span="14" :xs="24" class="mb-3">
              <div class="card-content">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="12" class="text-left">
                    <div class="jp-line-blue"></div>
                    <h3>{{$t('home.technologyName1')}}</h3>
                  </el-col>
                </el-row>
                <div class="card-text">
                  <p>{{$t('home.technologyContent1')}}</p>
                </div>
              </div>
            </el-col>
          </el-row> -->
          <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
            <el-col :span="12" :xs="24" class="mb-3 hidden-sm-and-up">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology1" class="image w-100 technology-img">
              </div>
            </el-col>
            <el-col :span="12" :xs="24" class="mb-3">
              <div class="card-content">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="14" class="text-left">
                    <div class="jp-line-blue"></div>
                    <h3>{{$t('home.technologyName2')}}</h3>
                    <h3 class="en-title">Polyimide</h3>
                  </el-col>
                </el-row>
                <div class="card-text">
                  <p>{{$t('home.technologyContent2')}}</p>
                  <p class="en-content">Excellent chemical corrosion resistance, thermodynamic stability and mechanical properties, polyimide is considered as one of the most promising polymer materials.</p>
                </div>
              </div>
            </el-col>
            <el-col :span="10" :xs="24" class="mb-3 hidden-xs-only">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology1" class="image w-100 technology-img">
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if="type === 3">
          <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
            <el-col :span="12" :xs="24" class="mb-3">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology3" class="image w-100 technology-img">
              </div>
            </el-col>
            <el-col :span="12" :xs="24" class="mb-3">
              <div class="card-content">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="14" class="text-left">
                    <div class="jp-line-blue"></div>
                    <h3>{{$t('home.technologyName3')}}</h3>
                    <h3 class="en-title">Bio-degradable plastics</h3>
                  </el-col>
                </el-row>
                <div class="card-text">
                  <p>{{$t('home.technologyContent3')}}</p>
                  <p class="en-content">Degradable Plastics can be decomposed into low-molecules by sunlight or microorganisms, and can be degraded into environmentally harmless substances under natural environment.</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
            <el-col :span="10" :xs="24" class="mb-3 hidden-sm-and-up">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology4" class="image w-100 technology-img">
              </div>
            </el-col>
            <el-col :span="14" :xs="24" class="mb-3">
              <div class="card-content">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="15" class="text-left">
                    <div class="jp-line-blue"></div>
                    <h3>{{$t('home.technologyName4')}}</h3>
                  </el-col>
                </el-row>
                <div class="card-text">
                  <p>{{$t('home.technologyContent4')}}</p>
                </div>
              </div>
            </el-col>
            <el-col :span="10" :xs="24" class="mb-3 hidden-xs-only">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology4" class="image w-100 technology-img">
              </div>
            </el-col>
          </el-row> -->
        </div>
        <div v-if="type === 2">
          <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
            <el-col :span="12" :xs="24" class="mb-3">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology5" class="image w-100 technology-img">
              </div>
            </el-col>
            <el-col :span="12" :xs="24" class="mb-3">
              <div class="card-content">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="24" class="text-left">
                    <div class="jp-line-blue"></div>
                    <h3>{{$t('home.technologyName5')}}</h3>
                    <h3 class="en-title">H2 storage & transport</h3>
                  </el-col>
                </el-row>
                <div class="card-text">
                  <p>{{$t('home.technologyContent5')}}</p>
                  <p class="en-content">High heat of combustion, water as combustion product, Hydrogen is the cleanest energy in the world, which is rich in resources and sustainable.</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if="type === 4">
          <el-row :type="rowType" :gutter="30" class="jp-project-content" align="middle">
            <el-col :span="10" :xs="24" class="mb-3 hidden-sm-and-up">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology6" class="image w-100 technology-img">
              </div>
            </el-col>
            <el-col :span="14" :xs="24" class="mb-3">
              <div class="card-content">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-col :span="15" class="text-left">
                    <div class="jp-line-blue"></div>
                    <h3>{{$t('home.technologyName6')}}</h3>
                    <h3 class="en-title">Microreactor</h3>
                  </el-col>
                </el-row>
                <div class="card-text">
                  <p>{{$t('home.technologyContent6')}}</p>
                  <p class="en-content">The continuous flow reaction of microreactor can minimize the by-products, to realize energy saving and operating safety.</p>
                </div>
              </div>
            </el-col>
            <el-col :span="10" :xs="24" class="mb-3 hidden-xs-only">
              <div class="jp-overflow-hidden t-card">
                <img :src="technology6" class="image w-100 technology-img">
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import mainBg from '@/assets/img/main_bg.png';
import technology1 from '@/assets/img/t1-2.jpg';
import technology2 from '@/assets/img/t1-1.png';
import technology3 from '@/assets/img/t1-3.jpg';
import technology4 from '@/assets/img/t1-4.png';
import technology5 from '@/assets/img/t1-5.jpg';
import technology6 from '@/assets/img/t1-6.jpg';
export default {
  name: 'actiEdit',
  data () {
    return {
      rowType: '',
      type: '',
      title: '',
      title_en: '',
      mainBg: mainBg,
      technology1: technology1,
      technology2: technology2,
      technology3: technology3,
      technology4: technology4,
      technology5: technology5,
      technology6: technology6,
    }
  },
  watch: {
    '$i18n.locale'() {
      this.showTitleName();
    }
  },
  created() {
    this.type = parseInt(this.$route.query.type);
    this.showTitleName();
    this.getWidth();
  },
  methods: {
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
      } else {
        this.rowType = 'flex'
      }
    },
    showTitleName() {
      switch (this.type) {
        case 1:
          this.title = this.$t('acti.businessName1');
          this.title_en = 'New material';
          break;
        case 2:
          this.title = this.$t('acti.businessName2');
          this.title_en = 'Green energy';
          break;
        case 3:
          this.title = this.$t('acti.businessName3');
          this.title_en = 'Green environmental protection';
          break;
        case 4:
          this.title = this.$t('acti.businessName4');
          this.title_en = 'New petrochemical technology';
          break;
        default:
          this.title = ''
          this.title_en = '';
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

.acti-edit {}

</style>



// WEBPACK FOOTER //
// src/view/actiEdit.vue